

interface PromoPreviewProps {
    id:string
    logo?:string
    bulletpoints?:string
    infoText?:string
    extraLinks?:string
}

const PromoPreview = ({id, logo, bulletpoints, infoText, extraLinks}: PromoPreviewProps) => {

    let baseUrl = `https://www.1881.no/tlf/x_${id}/demo`
    const params: string[] = [];

    const disable = id === "" || (!(logo !== undefined && logo.length > 0 ) && !(bulletpoints !== undefined && bulletpoints.length > 0 ) && !(infoText  !== undefined && infoText.length > 0) &&  !(extraLinks  !== undefined && extraLinks.length > 0));

    if (infoText) {
        params.push(`infotext=true`, `customdescription=${encodeURIComponent(infoText)}`);
    }
    if (logo) {
        params.push(`logo=true`, `customlogo=${encodeURIComponent(logo)}`);
    }
    if (bulletpoints) {
        params.push(`bulletpoints=true`, `custombulletpoints=${encodeURIComponent(bulletpoints)}`);
    }
    if (extraLinks) {
        params.push(`links=true`, `customlinks=${encodeURIComponent(extraLinks)}`);
    }

    const url = `${baseUrl}?${params.join("&")}`;

    return <div className="mb-4 mb-md-0">
         {!disable ? <a href={url} target="_blank">Forhåndsvisning <i className="bi bi-box-arrow-up-right"></i></a> : <>Forhåndsvisning <i className="bi bi-box-arrow-up-right"></i></>}
        </div>

}

export default PromoPreview;